import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import validator from 'validator';
import { Grid, Header, Form, Button } from 'semantic-ui-react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { login } from 'state/session/actions';
import ValidatedFormInput from 'components/ValidatedFormInput';
import styles from './Login.module.css';

const requiredValidation = (value = '') =>
  !validator.isEmpty(value) ? undefined : 'This field is required';

class LoginPage extends React.Component {
  onLoginSubmit = ({ username, password }) => {
    const { dispatch } = this.props;
    dispatch(login(username, password));
  };

  render() {
    const { handleSubmit, isLoggedIn, isLoggingIn, location } = this.props;
    const previousPath = location.state ? location.state.previousPath : '/';
    if (isLoggedIn) {
      return <Redirect to={previousPath} />;
    }

    return (
      <div className={styles['login-container']}>
        <Grid textAlign="center">
          <Grid.Column width={6}>
            <SemanticToastContainer />
            <Header>Moka Internal Tools</Header>
            <Form onSubmit={handleSubmit(this.onLoginSubmit)}>
              <Field
                id="username"
                name="username"
                component={ValidatedFormInput}
                icon="user"
                iconPosition="left"
                placeholder="Username"
                autoFocus
                validate={requiredValidation}
              />
              <Field
                id="password"
                name="password"
                component={ValidatedFormInput}
                icon="lock"
                iconPosition="left"
                placeholder="Password"
                type="password"
                validate={requiredValidation}
              />
              <Button
                type="submit"
                fluid
                primary
                loading={isLoggingIn}
                disabled={isLoggingIn}
              >
                Login
              </Button>
            </Form>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = ({ session }) => ({
  isLoggedIn: session.currentUser !== null,
  isLoggingIn: session.isLoggingIn,
});

LoginPage.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  isLoggingIn: PropTypes.bool.isRequired,
  location: PropTypes.any.isRequired,
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'login',
  })(LoginPage)
);
